import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { VIEW_MODE_MAP, PERMISSION_VIEW_MAP } from '@/config/routeConfig';

const RouteGuard = ({ children, requiredPermission, viewType }) => {
  const location = useLocation();
  const viewMode = useSelector(state => state.App.viewMode);
  const permissions = useSelector(state => state.Auth.permission || {});
  const role = useSelector(state => state.Auth.role || {});
  const isSuperUser = Object.keys(role)[0] === '1.0';
  console.log('isSuperUser', isSuperUser);
  
  // 超级管理员拥有所有权限，直接通过
  if (isSuperUser) {
    return children;
  }

  // 获取当前视图类型
  const currentViewType = VIEW_MODE_MAP[viewMode];
  
  // 判断是否为内部路由（以特定前缀开头）
  const isInternalRoute = location.pathname.startsWith('/admin/') || 
                         location.pathname.startsWith('/facility/') || 
                         location.pathname.startsWith('/portfolio/');
  
  // 获取内部错误页面路径
  const getInternalErrorPath = (errorType) => {
    if (isInternalRoute) {
      return `/${viewType}/${errorType}`;
    }
    return `/${errorType}`;
  };
  
  if(viewType === 'common') {
    return children;
  }

  // 检查路由是否匹配当前视图
  const isRouteMatchingView = viewType === currentViewType;
  
  // 如果路由不匹配当前视图，重定向到对应的404页面
  if (!isRouteMatchingView) {
    return <Navigate to={getInternalErrorPath('404')} replace />;
  }
  
  // 检查视图权限
  const viewPermissionKey = PERMISSION_VIEW_MAP[viewType];
  const hasViewPermission = permissions[viewPermissionKey] && permissions[viewPermissionKey] > 0;
  
  if (!hasViewPermission) {
    return <Navigate to={getInternalErrorPath('403')} replace />;
  }
  
  // 检查具体功能权限
  // 如果 requiredPermission 没有值，表示具有权限
  if (requiredPermission) {
    const hasPermission = permissions[requiredPermission] && permissions[requiredPermission] > 0;
    if (!hasPermission) {
      return <Navigate to={getInternalErrorPath('403')} replace />;
    }
  }
  
  return children;
};

export default RouteGuard; 